import React, { RefObject, useEffect, useState } from "react";
import { restartJob } from "../../helpers/apiHelper";
import Dialog from "./Dialog";
import { DerivedDialogProps } from "../../types/dialogTypes";

const RESTART_ALLOWED_TEXT = `Would you like to restart this job from the start? It will also
  restart the jobs following this one in the pipeline.`;
const RESTART_NOT_ALLOWED_TEXT = "Restart is not available for this step.";

export default function RestartDialog({ assetId, onSuccess, onFailure }: DerivedDialogProps) {
  const [jobId, setJobId] = useState("");
  const [jobLabel, setJobLabel] = useState("");
  const [restartAllowed, setRestartAllowed] = useState(false);
  const [dialogRef, setDialogRef] = useState<RefObject<HTMLDivElement> | null>(null);

  useEffect(() => {
    if (!dialogRef?.current) return;
    dialogRef.current.addEventListener("show.bs.modal", (event) => {
      // @ts-expect-error Property 'relatedTarget' does not exist on type 'Event'
      const trigger = event.relatedTarget as HTMLButtonElement;
      setJobId(trigger.getAttribute("data-job-id") ?? "");
      setRestartAllowed(trigger.getAttribute("data-restart-allowed") === "true");
      setJobLabel(trigger.textContent ?? "");
    });
  }, [dialogRef]);

  async function onRestartJob() {
    if (restartAllowed) return restartJob(assetId, jobId);
  }

  function getAlertText(error: string) {
    return `Failed to restart ${jobLabel}, please try again. Error: ${error}`;
  }

  return (
    <Dialog
      id="restart-modal"
      headerText="Restart Job"
      body={restartAllowed ? RESTART_ALLOWED_TEXT : RESTART_NOT_ALLOWED_TEXT}
      submitText={restartAllowed ? "Restart" : ""}
      onSubmit={onRestartJob}
      onSuccess={onSuccess}
      onFailure={error => onFailure && onFailure(getAlertText(error))}
      onRefChange={setDialogRef}
    />
  );
}
